<template>
  <v-form
    :class="$style.host"
    @submit.prevent="submit"
  >
    <div :class="$style.label">
      <span>Enter Your Company Name *</span>
    </div>
    <v-text-field
      v-model="distributorCompany"
      dense
      outlined
      hide-details
    ></v-text-field>
    <v-btn
      color="primary"
      type="submit"
      :class="['unr-button', $style.button]"
      :disabled="!distributorCompany.length || loading"
    >
      Continue
    </v-btn>
  </v-form>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import {
  SET_DISTRIBUTOR_COMPANY,
  SET_DISTRIBUTOR_ERROR,
  START_LOADING,
  STOP_LOADING,
  VERIFY_COMPANY,
} from '@/features/registration/store/modules/registration';
import { ServerValidationError } from '@/axios/exceptions';

export default {
  name: 'DistributorFormCompany',
  data: () => ({
    distributorCompany: '',
  }),
  computed: mapState([
    'loading',
  ]),
  methods: {
    ...mapMutations({
      setDistributorCompany: SET_DISTRIBUTOR_COMPANY,
      setDistributorError: SET_DISTRIBUTOR_ERROR,
      startLoading: START_LOADING,
      stopLoading: STOP_LOADING,
    }),
    ...mapActions({
      verifyCompany: VERIFY_COMPANY,
    }),
    async submit() {
      this.startLoading();
      try {
        await this.verifyCompany(this.distributorCompany);
        this.setDistributorCompany(this.distributorCompany);
      } catch (error) {
        if (error instanceof ServerValidationError) {
          this.setDistributorError(error.message);
        } else {
          this.$notify({
            group: 'foo',
            type: 'error',
            title: 'Error',
            text: error.message,
          });
        }
      } finally {
        this.stopLoading();
      }
    },
  },
  watch: {
    distributorCompany() {
      this.setDistributorError();
    },
  },
};
</script>

<style lang="scss" module>
.host {
  margin-top: 15px;

  .label {
    text-align: left;

    > span {
      @include font-open-sans-grey(16px, 600, 24px);
    }
  }

  .button {
    margin-top: 25px;
  }
}
</style>
